import {
  Component,
  Input,
  Output,
  EventEmitter,
  TemplateRef
} from '@angular/core';

export type ListType = 'text' | 'checkbox' | 'radio' | 'custom';
export type ListSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent {
  @Input() items: any[] = [];
  @Input() listType: ListType = 'text';
  @Input() size: ListSize = 'medium';
  @Input() displayField: string = 'name';
  @Input() valueField: string = 'id';
  @Input() striped: boolean = false;
  @Input() bordered: boolean = true;
  @Input() interactive: boolean = true;
  @Input() selectable: boolean = false;
  @Input() multiSelect: boolean = false;
  @Input() itemTemplate: TemplateRef<any> | null = null;
  @Input() disabled: boolean = false;

  @Output() itemSelect = new EventEmitter<any>();
  @Output() itemClick = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any[]>();

  selectedItems = new Set<any>();

  onItemClick(item: any): void {
    this.itemClick.emit(item);

    if (this.selectable) {
      if (this.multiSelect) {
        if (this.selectedItems.has(item)) {
          this.selectedItems.delete(item);
        } else {
          this.selectedItems.add(item);
        }
      } else {
        this.selectedItems.clear();
        this.selectedItems.add(item);
      }
      this.itemSelect.emit(item);
      this.selectionChange.emit(Array.from(this.selectedItems));
    }
  }

  isItemSelected(item: any): boolean {
    return this.selectedItems.has(item);
  }

  getDisplayValue(item: any): string {
    if (typeof item === 'string' || typeof item === 'number') {
      return String(item);
    }
    return typeof item === 'object' && item[this.displayField]
      ? item[this.displayField]
      : '';
  }

  getListClasses(): { [key: string]: boolean } {
    return {
      'list-striped': this.striped,
      'list-bordered': this.bordered,
      'list-interactive': this.interactive,
      'list-disabled': this.disabled,
      [`list-${this.size}`]: true
    };
  }

  getItemClasses(item: any): { [key: string]: boolean } {
    return {
      'list-item-selected': this.isItemSelected(item),
      'list-item-checkbox': this.listType === 'checkbox',
      'list-item-radio': this.listType === 'radio',
      'list-item-custom': this.listType === 'custom'
    };
  }
}
